import { render, staticRenderFns } from "./guolv1.vue?vue&type=template&id=5f8245f4&scoped=true&"
import script from "./guolv1.vue?vue&type=script&lang=js&"
export * from "./guolv1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8245f4",
  null
  
)

export default component.exports